
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { hideLoading, showLoading } from '@/fit-components/loading/main';
import { showBusinessError } from '@/fit-components/dialog/main';
import VHeader from '../components/sub-header.vue';
import Card from '../components/info-card.vue';
import { queryTraffic, queryCases } from '../api';
import { NcovDataType } from '../types';
import { util, biHottag, language } from '@tencent/ppd-base-libs';
import { i18n } from '@/i18n';
import LoadFailed from '@/components/load-failed.vue';

export enum PageType {
  traffic = 'traffic',
  cases = 'cases',
}

@Component({
  components: { VHeader, Card, LoadFailed },
})
export default class CardList extends Vue {
  @Prop({ default: 'cases' }) public pageType!: PageType;
  bannerType = '';
  lang = language.getLanguage();
  trafficData = [];
  casesData = [];
  loadFailed = false;

  get isTraffic() {
    return 'traffic' === this.pageType;
  }

  get isCases() {
    return 'cases' === this.pageType;
  }

  get title() {
    if (this.isTraffic) {
      return i18n('确认个案曾乘搭的交通工具查询');
    }
    if (this.isCases) {
      return i18n('本港确诊新型冠状病毒的个案详情');
    }
  }

  get dataset() {
    if (this.isTraffic) {
      return this.trafficData;
    }
    if (this.isCases) {
      return this.casesData;
    }
  }
  async activated() {
    showLoading();
    this.loadFailed = false;
    if (this.isCases) {
      this.bannerType = this.pageType;
      util.changeTitle(i18n('個案詳情'));
      biHottag('wallet.cvirus.cases.index_brow');
      const [err, data] = await util.to(queryCases());
      if (err) {
        hideLoading();
        this.loadFailed = true;
        return;
      }
      const { f_ncov_data } = data;
      this.casesData = f_ncov_data;
    }
    hideLoading();
  }
  deactivated() {
    this.casesData = [];
    this.trafficData = [];
    this.bannerType = '';
  }
}
